import React from "react";
import ItemExperience from "./ItemExperience";

export default function ListExperience(second) {
	return (
		<>
			<div className="w-auto md:w-11/12">
				<ol className="relative border-l border-gray-200 dark:border-gray-700">
					<ItemExperience
						title="Software Developer"
						date="Juli 2023 - Present"
						decs={
							<ul className="list-disc pl-4">
								<li>
									Developed and maintained higher-education digital services
									used by 400+ universities in Indonesia, contributing to
									Academic, PMB (Admissions), Simkerma, and MauKuliah modules.
								</li>
								<li>
									Built government-backed systems including Beasiswa Sawit
									SDMPKS (Ministry of Agriculture) and Patriot Connect Research
									Portal (Ministry of Transmigration).
								</li>
								<li>
									Utilized PHP, JavaScript, Laravel, PostgreSQL, and related
									technologies to deliver scalable web applications.
								</li>
								<li>
									Delivered new features and fixes with an on-time completion
									rate of ~80%, aligned with sprint and Kanban productivity
									targets.
								</li>
								<li>
									Reduced operational costs by optimizing SQL queries and
									eliminating N+1 issues in database access.
								</li>
								<li>
									Produced 9 types of custom academic reports per university,
									completing 50+ SLA tasks monthly.
								</li>
								<li>
									Generated recurring revenue of ~IDR 3M/month through
									continuous enhancement of custom report solutions.
								</li>
							</ul>
						}
						latest={true}
						company="SENTRA VIDYA UTAMA"
					/>
					<ItemExperience
						title="Frontend Development"
						date="December 2022 - December 2023"
						decs={
							<ul className="list-disc pl-4">
								<li>
									Developed an information system project inspired by Traveloka,
									featuring tourism, culinary, accommodation, transportation,
									and local crafts across the Madura region, as part of an
									initiative to promote local businesses and increase university
									revenue.
								</li>
								<li>
									Built the frontend interface using ReactJS and Tailwind CSS to
									enhance development efficiency and design consistency.
								</li>
								<li>
									Collaborated with the backend team to develop RESTful APIs,
									ensuring seamless integration with the web interface.
								</li>
							</ul>
						}
						company="UNIVERSITAS TRUNOJOYO MADURA"
					/>
					{/* <ItemExperience
						title="Front End Development Intern"
						date="September 2022 - December 2022"
						decs="In the Bangbeli Internship Program, internal participants will be faced with Project-Based learning methods, work on real projects at Bangbeli and are responsible for solving these problems, get enrichment materials from companies to develop skills, and get regular guidance from mentors."
					/> */}
					<ItemExperience
						title="Front End Engineering Bootcamp Student"
						date="February 2022 - July 2022"
						decs={
							<ul className="list-disc pl-4">
								<li>
									Ruangguru collaborates with Merdeka Campus as a step to
									realize these opportunities through the Independent Study
									program. Creating high-quality websites and dynamic
									applications to provide the best user experience is critical
									to increasing the competitiveness of a product or service.
								</li>
							</ul>
						}
						company="RUANGGURU"
					/>
					<ItemExperience
						title="Lab Assistant"
						date="July 2021 - July 2022"
						decs={
							<ul className="list-disc pl-4">
								<li>
									Responsible as an intermediary of knowledge from lecturers to
									students in practicum activities by providing material,
									guiding, and evaluating students in one class of web
									application programming, Database I, Database II, introductory
									information technology.
								</li>
							</ul>
						}
						company="UNIVERSITAS TRUNOJOYO MADURA"
					/>
				</ol>
			</div>
		</>
	);
}
